/** A visual tone for a portal status pill. */
export type PortalPillTone = 'accent' | 'success' | 'neutral' | 'info';

const TONE: Record<PortalPillTone, { wrap: string; dot: string }> = {
  // Needs the customer / warm attention (awaiting approval, due).
  accent: { wrap: 'bg-portal-accent-surface text-portal-accent', dot: 'bg-portal-accent' },
  // Resolved / good (approved, paid, complete).
  success: { wrap: 'bg-success-surface text-success', dot: 'bg-success' },
  // Inert / closed (expired, declined, cancelled).
  neutral: { wrap: 'bg-muted text-muted-foreground', dot: 'bg-muted-foreground' },
  // Scheduled / in-progress.
  info: { wrap: 'bg-muted text-foreground/70', dot: 'bg-foreground/50' },
};

/**
 * The uppercase, dotted status pill used across the customer portal (estimates,
 * invoices, visits). Matches the portal design — small caps, a leading status
 * dot, and a tone-tinted surface.
 */
export function PortalStatusPill({ label, tone }: { label: string; tone: PortalPillTone }) {
  const t = TONE[tone];
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${t.wrap}`}
    >
      <span className={`size-1.5 rounded-full ${t.dot}`} />
      {label}
    </span>
  );
}
